import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import tracking from 'dibs-tracking';

import { SharedBreadcrumbs } from '../../components/global/SharedBreadcrumbs/SharedBreadcrumbs';
import { FormattedMessage } from 'react-intl';

import { updateUriRef } from '../../actions/filterActions';
import { getAppliedFilter } from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';

// some breadcrumbs are not search / browse pages, but special landing pages instead :
const specialCaseLinks = [
    'creators',
    'collections',
    'seller-directory',
    // home page
    '',
];

const backToItemDefaultMessage = (
    <FormattedMessage id="SbSharedPageBreadcrumbs.backToItem" defaultMessage="< Back To Item" />
);

const testSpecialCase = path => specialCaseLinks.includes(path.replace(/\//g, ''));

class SbSharedPageBreadcrumbsComponent extends Component {
    constructor(props) {
        super(props);
        this.updateRoute = this.updateRoute.bind(this);
        this.fireTracking = this.fireTracking.bind(this);
    }

    updateRoute(e) {
        const path = e.target.pathname;
        const shouldUpdateRoute =
            !testSpecialCase(path) &&
            // more from seller links directly back to PDP and shouldn't be
            // caught by SB router
            !this.isMoreFromSeller();

        if (shouldUpdateRoute) {
            e.preventDefault();
            this.fireTracking(e);
            if (this.props.updateUriRef) {
                this.props.updateUriRef(path);
            }
        }
    }

    fireTracking(e) {
        const breadcrumbs = get(this.props, 'searchBrowse.breadcrumbs');
        const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
        const currentCategoryName = get(lastBreadcrumb, 'displayName');

        tracking.trackEvent({
            category: 'navigation',
            action: 'breadcrumb click',
            label: `${currentCategoryName}|${e.target.text}`,
        });
    }

    isMoreFromSeller() {
        const pageType = get(this.props, 'searchBrowse.pageType');
        return pageType === pageTypes.MORE_FROM_SELLER;
    }

    getItemPk() {
        const appliedFilters = get(this.props, 'searchBrowse.appliedFilters');
        const itemPkFilter = getAppliedFilter(appliedFilters, 'itemPk');

        return get(itemPkFilter, 'values[0].urlLabel');
    }

    render() {
        let breadcrumbs = get(this.props, 'searchBrowse.breadcrumbs');
        const isMoreFromSeller = this.isMoreFromSeller();
        const itemPk = this.getItemPk();

        if (isMoreFromSeller && itemPk) {
            breadcrumbs = [
                {
                    displayName: backToItemDefaultMessage,
                    path: `/id-${itemPk}`,
                },
            ];
        }

        return (
            <SharedBreadcrumbs
                breadcrumbs={breadcrumbs}
                onClick={this.updateRoute}
                isLastItemActive={isMoreFromSeller}
            />
        );
    }
}

SbSharedPageBreadcrumbsComponent.propTypes = {
    searchBrowse: PropTypes.object,
    updateUriRef: PropTypes.func,
};

SbSharedPageBreadcrumbsComponent = connect(
    null,
    { updateUriRef }
)(SbSharedPageBreadcrumbsComponent);

export const SbSharedPageBreadcrumbs = createFragmentContainer(SbSharedPageBreadcrumbsComponent, {
    searchBrowse: graphql`
        fragment SbSharedPageBreadcrumbs_searchBrowse on SearchBrowseQueryConnection {
            pageType
            appliedFilters {
                name
                values {
                    urlLabel
                }
            }
            breadcrumbs {
                displayName
                path
            }
        }
    `,
});
